<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1>Prodeje</h1>
      <v-layout class="layout--controls">
        <!-- <vue-json-to-csv
          class="v-btn secondary control v-btn&#45;&#45;contained theme&#45;&#45;light v-size&#45;&#45;default button&#45;&#45;top"
          :json-data="json.data"
          :labels="json.labels"
          :csv-title="json.title"
        >
          Exportovat
        </vue-json-to-csv> -->
        <download-excel
          class="v-btn secondary control v-btn--contained theme--light v-size--default button--top"
          :data="json.data"
          :fields="json.labels"
          type="xls"
          :name="json.title"
          :meta="json.meta"
        >
          Exportovat
        </download-excel>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="search"
          v-if="!grouped"
        ></v-text-field>
        <v-text-field
          class="input--search control"
          placeholder="Vyhledat"
          outlined
          v-model="searchGrouped"
          v-if="grouped"
        ></v-text-field>
        <v-btn
          color="primary"
          type="submit"
          class="button--top control"
          @click="groupAudiooboks()"
          ><span v-if="!grouped">Zgrupovat</span
          ><span v-else>Zrušit zgrupování</span></v-btn
        >
        <div class="button--top control">
          <v-autocomplete
            class="control select--top"
            :items="publishers"
            v-model="publisher"
            outlined
            item-value="id"
            item-text="name"
            placeholder="Vydavatel"
            @change="selectPublisher()"
          ></v-autocomplete>
        </div>
      </v-layout>

      <table class="info-table" style="margin-top: 50px">
        <tr>
          <td class="info-table__title">
            Zobrazit od:
          </td>
          <td class="info-table__value info-table__value--date">
            <v-text-field
              class="input--small"
              outlined
              disabled
              v-model="validFrom"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              type="submit"
              class="button--table"
              @click="openDialogValidFrom()"
            >
              Změnit
            </v-btn>
            <v-btn
              color="error"
              type="submit"
              class="button--table"
              @click="data.valid_from = null"
            >
              Zrušit
            </v-btn>
          </td>
        </tr>

        <tr>
          <td class="info-table__title">
            Zobrazit do:
          </td>
          <td class="info-table__value info-table__value--date">
            <v-text-field
              class="input--small"
              outlined
              disabled
              v-model="validTo"
            >
            </v-text-field>

            <v-btn
              color="secondary"
              type="submit"
              class="button--table"
              @click="openDialogValidTo()"
            >
              Změnit
            </v-btn>
            <v-btn
              color="error"
              type="submit"
              class="button--table"
              @click="data.valid_to = null"
            >
              Zrušit
            </v-btn>
          </td>
        </tr>
      </table>

      <v-layout class="table-items" v-if="!grouped">
        <v-data-table
          locale="cs"
          :headers="headers"
          :items="items"
          :search="search"
          :loading="false"
          item-key="name"
          :items-per-page="30"
          sort-by="created_at"
          :sort-desc="true"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr
                v-for="(item, index) in props.items"
                :key="item.id + '-' + index"
              >
                <router-link
                  :to="{
                    name: 'AudiobooksDetail',
                    params: { id: item.audiobook_id },
                  }"
                >
                  <td class="">
                    <span
                      v-if="item.image"
                      class="image-table image-table--photo"
                      :style="'background-image:url(' + item.image + ')'"
                    ></span>
                    <span v-else class="image-table"></span>
                  </td>
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">
                    {{
                      item.type == 'audiobook'
                        ? 'Audiokniha'
                        : item.type == 'ebook'
                        ? 'E-kniha'
                        : item.type == 'book'
                        ? 'Kniha'
                        : ''
                    }}
                  </td>
                  <td class="">{{ item.audiobook_name }}</td>

                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'AuthorsDetail',
                        params: { id: item.author_id },
                      }"
                    >
                      {{ item.author_forename }}<br />{{ item.author_surname }}
                    </router-link>
                  </td>
                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'PublishersDetail',
                        params: { id: item.publisher_id },
                      }"
                    >
                      {{ item.publisher_forename }}<br />{{
                        item.publisher_surname
                      }}
                    </router-link>
                  </td>
                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price"> {{ item.price }} Kč </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_no_dph }} Kč</span
                    >
                  </td>
                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'OrdersDetail',
                        params: { id: item.order_id },
                      }"
                    >
                      {{ item.number }}
                    </router-link>
                  </td>
                  <td class="small">
                    {{
                      item.voucher
                        ? item.voucher.code + ` (${item.voucher.price} kč)`
                        : ''
                    }}
                  </td>
                  <td class="small">{{ formatCreatedAt(item.created_at) }}</td>
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
      <v-layout class="table-items" v-else>
        <v-data-table
          locale="cs"
          :headers="headersGrouped"
          :items="itemsGrouped"
          :search="searchGrouped"
          :loading="false"
          item-key="name"
          :items-per-page="30"
          :mobile-breakpoint="0"
          class="elevation-1 full-width frankjoy-table"
        >
          <template slot="body" slot-scope="props">
            <tbody>
              <tr v-for="item in props.items" :key="item.id">
                <router-link
                  :to="{ name: 'AudiobooksDetail', params: { id: item.id } }"
                >
                  <td class="">
                    <span
                      v-if="item.image"
                      class="image-table image-table--photo"
                      :style="'background-image:url(' + item.image + ')'"
                    ></span>
                    <span v-else class="image-table"></span>
                  </td>
                  <td class="">{{ item.audiobook_id }}</td>
                  <td class="">
                    {{
                      item.type == 'audiobook'
                        ? 'Audiokniha'
                        : item.type == 'ebook'
                        ? 'E-kniha'
                        : item.type == 'book'
                        ? 'Kniha'
                        : ''
                    }}
                  </td>
                  <td class="">{{ item.audiobook_name }}</td>

                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'AuthorsDetail',
                        params: { id: item.author_id },
                      }"
                    >
                      {{ item.author_forename }}<br />{{ item.author_surname }}
                    </router-link>
                  </td>
                  <td class="bolder small">
                    <router-link
                      :to="{
                        name: 'PublishersDetail',
                        params: { id: item.publisher_id },
                      }"
                    >
                      {{ item.publisher_forename }}<br />{{
                        item.publisher_surname
                      }}
                    </router-link>
                  </td>

                  <td class="">{{ item.count }}x</td>
                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price"> {{ item.price }} Kč </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_no_dph }} Kč</span
                    >
                  </td>
                  <td class="bold">
                    <span class="actual-price">
                      <span v-if="item.price_all">
                        {{ item.price_all }} Kč
                      </span>
                      <span v-else>
                        0 Kč
                      </span>
                    </span>
                    <br />
                    <span class="small normal"
                      ><span class="small">Bez DPH</span>
                      {{ item.price_all_no_dph }} Kč</span
                    >
                  </td>
                  <!--<td class="bold">
                                   <span class="actual-price">
                                       <span v-if="item.price_avg">
                                        {{item.price_avg}} Kč
                                       </span>
                                       <span v-else>
                                           0 Kč
                                       </span>
                                   </span>
                                   <br>
                                   <span class="small normal"><span class="small">Bez DPH</span> {{item.price_avg_no_dph}} Kč</span>
                               </td>
                               <td class="bold">
                                   <span class="actual-price">
                                       <span v-if="item.price">
                                        {{item.price}} Kč
                                       </span>
                                       <span v-else>
                                           0 Kč
                                       </span>
                                   </span>
                                   <br>
                                   <span class="small normal"><span class="small">Bez DPH</span> {{item.price_no_dph}} Kč</span>
                               </td>-->
                </router-link>
              </tr>
              <div v-if="props.items.length == 0" class="text-no-results">
                <p>Žádná audiokniha nebyla nalezena</p>
              </div>
            </tbody>
          </template>
          <template slot="footer" slot-scope="totals">
            <div
              class="table-footer"
              v-bind:class="{
                'footer--no-results': totals.props.pagination.pageStop === 0,
              }"
            >
              <div class="table-footer__text">
                Počet audioknih na stránce
              </div>
              <div class="table-footer__pages">
                <span v-if="totals.props.pagination.pageStop > 0"
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart + 1 }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
                <span v-else
                  ><span class="table-footer__pages-bold"
                    >{{ totals.props.pagination.pageStart }}-{{
                      totals.props.pagination.pageStop
                    }}</span
                  >
                  z {{ totals.props.pagination.itemsLength }}</span
                >
              </div>
            </div>
          </template>
        </v-data-table>
      </v-layout>
    </div>

    <v-dialog v-model="dialogValidFrom" persistent>
      <v-card>
        <v-card-title class="headline">Zobrazit od</v-card-title>
        <v-date-picker
          v-model="data.valid_from"
          locale="cs-cz"
          :max="data.valid_to"
          @click:date="closeDialogValidFrom()"
        ></v-date-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogValidFrom()"
          >
            zrušit
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValidTo" persistent>
      <v-card>
        <v-card-title class="headline">Zobrazit do</v-card-title>
        <v-date-picker
          :min="data.valid_from"
          locale="cs-cz"
          v-model="data.valid_to"
          @click:date="closeDialogValidTo()"
        ></v-date-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="empty"
            class="button--dialog"
            @click="closeDialogValidTo()"
          >
            zrušit
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import VueJsonToCsv from 'vue-json-to-csv';

export default {
  name: 'Sales',
  components: {
    VueJsonToCsv,
  },

  data() {
    return {
      json: {
        data: [],
        labels: {},
        title: 'Prodeje',
      },
      grouped: false,
      loaded: false,
      searchGrouped: '',
      search: '',
      headers: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: '', value: 'image', sortable: false, align: 'left' },
        { text: 'ID', value: 'audiobook_id', align: 'left' },
        { text: 'Typ', value: 'type', align: 'left' },
        { text: 'Audiokniha', value: 'audiobook_name', align: 'left' },
        { text: 'Autor', value: 'author_forename', align: 'left' },
        { text: 'Vydavatel', value: 'publisher_forename', align: 'left' },
        { text: 'Cena', value: 'price', align: 'left' },
        { text: 'Objednávka', value: 'number', align: 'left' },
        { text: 'Kód', value: 'voucher', align: 'left' },
        { text: 'Koupeno', value: 'created_at', align: 'left' },
      ],
      items: [],
      itemsAll: [],
      headersGrouped: [
        //  { text: '', value: '',  align: 'left',sortable: false },
        { text: '', value: 'image', sortable: false, align: 'left' },
        { text: 'ID', value: 'audiobook_id', align: 'left' },
        { text: 'Typ', value: 'type', align: 'left' },
        { text: 'Audiokniha', value: 'audiobook_name', align: 'left' },
        { text: 'Autor', value: 'author_forename', align: 'left' },
        { text: 'Vydavatel', value: 'publisher_forename', align: 'left' },
        { text: 'Počet kusů', value: 'count', align: 'left' },
        { text: 'Cena za kus', value: 'price_avg', align: 'left' },
        { text: 'Celková cena', value: 'price', align: 'left' },
      ],
      itemsGrouped: [],
      itemsGroupedAll: [],
      publishers: [],
      publisher: null,
      dialogValidTo: false,
      dialogValidFrom: false,
      data: {
        valid_from: moment(new Date()).format('YYYY-MM-DD'),
        valid_to: moment(new Date()).format('YYYY-MM-DD'),
      },
    };
  },

  created() {
    this.fetchData();

    this.fetchPublishers();

    this.prepareExport();
  },
  computed: {
    ...mapState(['profile']),

    validTo() {
      if (this.data.valid_to) {
        return moment(this.data.valid_to).format('DD.MM.YYYY');
      } else {
        return null;
      }
    },
    validFrom() {
      if (this.data.valid_from) {
        return moment(this.data.valid_from).format('DD.MM.YYYY');
      } else {
        return null;
      }
    },
  },
  mounted() {},
  methods: {
    openDialogValidTo() {
      this.dialogValidTo = true;
    },
    closeDialogValidTo() {
      this.dialogValidTo = false;
    },
    openDialogValidFrom() {
      this.dialogValidFrom = true;
    },
    closeDialogValidFrom() {
      this.dialogValidFrom = false;
    },
    groupAudiooboks() {
      this.grouped = !this.grouped;
      this.prepareExport();
    },

    formatCreatedAt(date) {
      if (date) {
        return moment.unix(date).format('D.M.YYYY - HH:mm');
      } else {
        return null;
      }
    },
    fetchData() {
      this.$axios
        .get(
          '/admin/orders/billing?valid_from=' +
            this.validFrom +
            '&valid_to=' +
            this.validTo +
            '&view=sales'
        )
        .then((response) => {
          this.items = response.data.billing;
          this.itemsGrouped = response.data.billing_grouped;

          this.itemsAll = response.data.billing;
          this.itemsGroupedAll = response.data.billing_grouped;

          this.prepareExport();
          this.loaded = true;
        })
        .catch((e) => {
          this.prepareExport();
          this.loaded = true;
        });
    },

    selectPublisher() {
      if (this.$route.query.publisher) {
        this.$router.replace({ query: null });
      }

      this.changeData();
    },
    fetchPublishers() {
      this.$axios
        .get('/admin/publishers')
        .then((response) => {
          this.publishers = response.data.publishers;
          this.publishers.push({
            id: null,
            name: 'Všichni vydavatelé',
          });

          if (
            this.$route.query.publisher &&
            this.publishers.find(
              (item) => item.id === this.$route.query.publisher
            )
          ) {
            this.publisher = this.$route.query.publisher;
          }
          this.changeData();
          this.prepareExport();
        })
        .catch((e) => {
          this.prepareExport();
        });
    },
    prepareExport() {
      var jsonData = [];
      var publisher_name = '';
      if (this.grouped) {
        this.itemsGrouped.forEach((item) => {
          var price = 0;
          if (item.price) {
            price = item.price;
          }

          var price_no_dph = 0;
          if (item.price_no_dph) {
            price_no_dph = item.price_no_dph;
          }

          var price_avg = 0;
          if (item.price_avg) {
            price_avg = item.price_avg;
          }

          var price_avg_no_dph = 0;
          if (item.price_avg_no_dph) {
            price_avg_no_dph = item.price_avg_no_dph;
          }

          var count = 0;
          if (item.count) {
            count = item.count;
          }

          // jsonData.push({
          //   id: item.audiobook_id,
          //   audiobook: item.audiobook_name,
          //   author: item.author_forename + " " + item.author_surname,
          //   publisher: item.publisher_forename + " " + item.publisher_surname,
          //   count: count,
          //   price_avg: price_avg,
          //   price_avg_no_dph: price_avg_no_dph,
          //   price: price,
          //   price_no_dph: price_no_dph,
          //   vouchers: item.vouchers_str,
          // });

          publisher_name = item.publisher_forename;
          if (item.publisher_surname) {
            publisher_name =
              item.publisher_forename + ' ' + item.publisher_surname;
          }

          var author_name = item.author_forename;
          if (item.author_surname) {
            author_name = item.author_forename + ' ' + item.author_surname;
          }

          var price_provision = 0;
          if (item.price_provision) {
            price_provision = item.price_provision;
          }

          var price_provision_no_dph = 0;
          if (item.price_provision_no_dph) {
            price_provision_no_dph = item.price_provision_no_dph;
          }

          var price_provision_publisher = 0;
          if (item.price_provision_publisher) {
            price_provision_publisher = item.price_provision_publisher;
          }

          var price_provision_publisher_no_dph = 0;
          if (item.price_provision_publisher_no_dph) {
            price_provision_publisher_no_dph =
              item.price_provision_publisher_no_dph;
          }

          jsonData.push({
            id: item.audiobook_id,
            order_id: item.order_id,
            audiobook: item.audiobook_name,
            type: item.type == 'audiobook' ? 'Audiokniha' : item.type == 'ebook' ? 'E-kniha' : item.type == 'book' ? 'kniha' : '',
            created_at: this.formatCreatedAt(item.created_at),
            author: item.author_forename + ' ' + item.author_surname,
            publisher: item.publisher_forename + ' ' + item.publisher_surname,
            price: price,
            count: count,
            price_no_dph: price_no_dph,
            price_original: item.price_original,
            price_provision_publisher: String(
              price_provision_publisher
            ).replace('.', ','),
            price_provision_publisher_no_dph: String(
              price_provision_publisher_no_dph
            ).replace('.', ','),
            voucher: item.voucher ? item.voucher.code : '',
            voucher_price: item.voucher ? item.voucher.price : '',
            voucher_code: item.voucher ? item.voucher.code : '',
          });
        });

        this.json.data = jsonData;
        // this.json.labels = {
        //   id: { title: "ID knihy" },
        //   audiobook: { title: "Audiokniha" },
        //   author: { title: "Autor" },
        //   publisher: { title: "Vydavatel" },
        //   count: { title: "Počet kusů" },
        //   price_avg: { title: "Průměrná cena" },
        //   price_avg_no_dph: { title: "Průměrná cena bez DPH" },
        //   price: { title: "Celková cena" },
        //   price_no_dph: { title: "Celková cena bez DPH" },
        //   vouchers: { title: "Použité kódy" },
        // };
        this.json.labels = {
          'ID knihy': 'id',
          Audiokniha: 'audiobook',
          Typ: 'type',
          Vytvořeno: 'created_at',
          Autor: 'author',
          'Objednávka z apple': 'ios_receipt',
          Vydavatel: 'publisher',
          'Počet kusů': 'count',
          'Celková cena': 'price',
          'Cena bez DPH': 'price_no_dph',
          'Provize Progresguru': 'price_provision',
          'Provize Progresguru bez DPH': 'price_provision_no_dph',
          'Fakturace vydavatel': 'price_provision_publisher',
          'Fakturace vydavatel bez DPH': 'price_provision_publisher_no_dph',
        };
      } else {
        this.items.forEach((item) => {
          var price = 0;
          if (item.price) {
            price = item.price;
          }

          var price_no_dph = 0;
          if (item.price_no_dph) {
            price_no_dph = item.price_no_dph;
          }

          publisher_name = item.publisher_forename;
          if (item.publisher_surname) {
            publisher_name =
              item.publisher_forename + ' ' + item.publisher_surname;
          }

          var author_name = item.author_forename;
          if (item.author_surname) {
            author_name = item.author_forename + ' ' + item.author_surname;
          }

          var price_provision = 0;
          if (item.price_provision) {
            price_provision = item.price_provision;
          }

          var price_provision_no_dph = 0;
          if (item.price_provision_no_dph) {
            price_provision_no_dph = item.price_provision_no_dph;
          }

          var price_provision_publisher = 0;
          if (item.price_provision_publisher) {
            price_provision_publisher = item.price_provision_publisher;
          }

          var price_provision_publisher_no_dph = 0;
          if (item.price_provision_publisher_no_dph) {
            price_provision_publisher_no_dph =
              item.price_provision_publisher_no_dph;
          }

          jsonData.push({
            id: item.audiobook_id,
            order_id: item.order_id,
            type: item.type == 'audiobook' ? 'Audiokniha' : item.type == 'ebook' ? 'E-kniha' : item.type == 'book' ? 'kniha' : '',
            audiobook: item.audiobook_name,
            created_at: this.formatCreatedAt(item.created_at),
            author: item.author_forename + ' ' + item.author_surname,
            publisher: item.publisher_forename + ' ' + item.publisher_surname,
            price: price,
            price_no_dph: price_no_dph,
            price_original: item.price_original,
            price_provision_publisher: String(
              price_provision_publisher
            ).replace('.', ','),
            price_provision_publisher_no_dph: String(
              price_provision_publisher_no_dph
            ).replace('.', ','),
            voucher: item.voucher ? item.voucher.code : '',
            voucher_price: item.voucher ? item.voucher.price : '',
            voucher_code: item.voucher ? item.voucher.code : '',
          });
        });

        this.json.data = jsonData;

        this.json.labels = {
          'ID objednávky': 'order_id',
          'ID knihy': 'id',
          Audiokniha: 'audiobook',
          Typ: 'type',
          Vytvořeno: 'created_at',
          Autor: 'author',
          'Objednávka z apple': 'ios_receipt',
          Vydavatel: 'publisher',
          Cena: 'price',
          'Původní cena': 'price_original',
          Kód: 'voucher_code',
          'Cena bez DPH': 'price_no_dph',
          'Provize Progresguru': 'price_provision',
          'Provize Progresguru bez DPH': 'price_provision_no_dph',
          'Fakturace vydavatel': 'price_provision_publisher',
          'Fakturace vydavatel bez DPH': 'price_provision_publisher_no_dph',
        };
        // this.json.labels = {
        //   "ID knihy": "id",
        //   Audiokniha: "audiobook",
        //   Autor: "author",
        //   Vydavatel: "publisher",
        //   Cena: "price",
        //   "Původní cena": "price_original",
        // };
        // this.json.labels = {
        //   id: { title: "ID knihy" },
        //   audiobook: { title: "Audiokniha" },
        //   created_at: { title: "Vytvořeno" },
        //   author: { title: "Autor" },
        //   publisher: { title: "Vydavatel" },
        //   price: { title: "Cena" },
        //   price_no_dph: { title: "Cena bez DPH" },
        //   voucher: { title: "Kód" },
        //   voucher_price: { title: "Sleva" },
        // };
      }

      this.$forceUpdate();
    },
    changeData() {
      var validFrom = null;
      if (this.data.valid_from) {
        validFrom = moment(this.data.valid_from).unix();
      }

      var validTo = null;
      if (this.data.valid_to) {
        validTo = moment(this.data.valid_to)
          .add(24, 'hours')
          .unix();
      }

      if (validFrom && validTo) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter(
            (item) => item.created_at >= validFrom && item.created_at <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.created_at >= validFrom && item.created_at <= validTo
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.created_at >= validFrom &&
              item.created_at <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.created_at >= validFrom &&
              item.created_at <= validTo
          );
        }
      } else if (validFrom) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter(
            (item) => item.created_at >= validFrom
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.created_at >= validFrom
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.created_at >= validFrom
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher &&
              item.created_at >= validFrom
          );
        }
      } else if (validTo) {
        if (this.publisher == null) {
          this.items = this.itemsAll.filter(
            (item) => item.created_at <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.created_at <= validTo
          );
        } else {
          this.items = this.itemsAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.created_at <= validTo
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) =>
              item.publisher_id === this.publisher && item.created_at <= validTo
          );
        }
      } else {
        if (this.publisher == null) {
          this.items = this.itemsAll;
          this.itemsGrouped = this.itemsGroupedAll;
        } else {
          this.items = this.itemsAll.filter(
            (item) => item.publisher_id === this.publisher
          );
          this.itemsGrouped = this.itemsGroupedAll.filter(
            (item) => item.publisher_id === this.publisher
          );
        }
      }

      this.prepareExport();
    },
  },
  watch: {
    'data.valid_from'() {
      this.fetchData();
    },
    'data.valid_to'() {
      this.fetchData();
    },
  },
};
</script>

<style lang="scss"></style>
